import ScanQR from "../../components/ScanQR/ScanQR"
import Navigation from "../../components/Navigation/Navigation";

const HomeView = () => {
    return (
        <>
        <Navigation />
        <ScanQR />
        </>
    );
}

export default HomeView;
